import type { HistoricalRow } from './HistoricalSnapshotHydrationService';

export const historicalImageCacheTable = 'checklist_marcacao_bkg_images';
export const matchesHistoricalImageCache = (cache: HistoricalRow | null, image: HistoricalRow): boolean => Boolean(
  cache?.base64 && cache.id === image.id && cache.empresa_id === image.empresa_id
  && cache.template_id === image.template_id && cache.campo_id === image.campo_id
);

export const materializeHistoricalImage = async (image: HistoricalRow, deps: {
  readCache(): Promise<HistoricalRow | null>;
  hasFile(): Promise<boolean>;
  download(): Promise<string>;
  onDownloadError?(error: unknown): void;
  revalidate(): Promise<boolean>;
  commit(row: HistoricalRow): Promise<number>;
}): Promise<boolean> => {
  const cache = await deps.readCache();
  if (cache) return matchesHistoricalImageCache(cache, image);
  if (await deps.hasFile()) return true;
  if (!await deps.revalidate()) return false;
  let base64: string;
  try {
    base64 = await deps.download();
  } catch (error) {
    // Falha de mídia conserva o retry, mas não impede receber outros modelos.
    deps.onDownloadError?.(error);
    return false;
  }
  // Download e FileReader não concedem autorização para gravar na sessão atual.
  if (!base64 || !await deps.revalidate()) return false;
  const inserted = await deps.commit({ id: image.id, base64, empresa_id: image.empresa_id,
    template_id: image.template_id, campo_id: image.campo_id, foto_url: image.id,
    created_at: Date.now(), updated_at: Date.now() });
  return inserted === 1 || matchesHistoricalImageCache(await deps.readCache(), image);
};
